import * as d3 from './d3';
import { intcomma } from 'journalize';
import checkmark from '../../assets/check.svg';

class RaceResults {
  constructor() {
    this.defaultProps = {
      pageMode: 'omnibus',
      recordKey: 'record_id',
    };
  }
  selection(selector) {
    if (!selector) return this._selection;
    this._selection = d3.select(selector);
    return this;
  }
  data(obj) {
    if (!obj) return this._data;
    this._data = obj;
    return this;
  }
  props(obj) {
    if (!obj) return this._props || this.defaultProps;
    this._props = { ...this.defaultProps, ...this._props, ...obj };
    return this;
  }
  render() {
    const data = this.data();
    const { raceID, pageMode, recordKey } = this.props();
    const es = d3.select('.elections-2020').attr('data-es') === 'true';

    let race;
    if (data.length > 0 && pageMode == 'omnibus') {
      race = data.find(d => d[recordKey] == raceID);
      if (!race && !race.total) {
        throw new Error(`Unable to find race with ID "${raceID}"`);
      }
    } else {
      race = data;
    }

    // ballot measure or candidate contest
    let type;
    if (race && race.contest_type) {
      type = race.contest_type;
    } else {
      throw new Error(`Race not found in given object or with ID "${raceID}"`);
    }

    const g = this.selection();

    const renderRaceTitle = d => {
      if (type == 'candidate_contest') {
        return d.seat_name !== ''
          ? `${d.office_name} — ${d.seat_name}`
          : `${d.office_name}`;
      } else if (type == 'ballot_measure') {
        return `${d.ballot_title} — ${d.ballot_description}`;
      }
    };

    // adds title
    g.appendSelect('h3')
      .datum(race)
      .attr('class', 'race-title')
      .text(renderRaceTitle);

    if (race && race.total && race.total.precincts_percentage >= 0) {
      const reportingText = es
        ? 'información de los precintos'
        : 'precincts reporting';
      // precincts reporting percent
      g.appendSelect('span')
        .datum(race)
        .attr('class', 'race-prec-rpt')
        .text(
          ({ total }) => {
            if (total.precincts_total <= 0) {
              return 'Precinct data not available'
            } else {
              return `${Math.round(total.precincts_percentage)}% ${reportingText}`
            }
          }
        );
    }

    const raceDataSorter = (type, race) => {
      if (type == 'ballot_measure') {
        return race.total.options
      } else {
        if (race.total.candidates.length > 5 && race.total.precincts_reporting > 0 && race.total.precincts_total > 0) {
          return race.total.candidates.sort((a, b) => b.votes_total - a.votes_total).slice(0, 5)
        } else {
          return race.total.candidates
        }
      }
    }

    // candidate name et al
    const canGroup = g
      .appendSelect('div', 'race-options')
      .datum(race)
      .call(g => {
        if (pageMode == 'homepage') {
          const header = g.appendSelect('div', 'options__header')
          header.appendSelect('h4', 'header__pct').text(es ? 'Por ciento' : 'Percent')
          header.appendSelect('h4', 'header__votes').text(es ? 'Votos' : 'Votes')
        } else {
          return;
        }
      })
      .selectAll('div.options__total')
      .data(
        raceDataSorter(type, race)
      )
      .join('div')
      .attr('class', 'options__total')
      .attr('data-party', ({ party }) =>
        party && party !== '' ? party.slice(0, 3) : null
      )
      .sort((a, b) => b.votes_total - a.votes_total);


    const name = canGroup.appendSelect('span', 'total__name');

    name
      .appendSelect('div', 'name__party')
      .attr('data-party', ({ party }) =>
        party && party !== '' ? party.toLowerCase() : null
      )
      .appendSelect('span', 'party__text')
      .text(({ party }) => {
        if (party && party !== '') {
          return party.slice(0, 3);
        } else {
          return null;
        }
      });

    const findWinner = d => {
      if (race.total.candidates && (d.winner == true || race.total.candidates.length < 2)) {
        return true
      } else if (d.winner == true) {
        return true
      } else {
        return false
      }
    }

    name
      .appendSelect('span', 'name__title')
      .text(d => (type == 'ballot_measure' ? d.option : d.name))
      .filter(findWinner)
      .appendSelect('div', 'name__winner-wrapper')
      .appendSelect('img', 'name__winner')
      .attr('src', checkmark);

    const percentBar = canGroup.appendSelect('div', 'total__percent');

    percentBar
      .appendSelect('div', 'percent__bar')
      .style('width', d => (d.votes_percentage || 0) + '%');

    percentBar
      .appendSelect('span', 'percent__num')
      .text(d => (d.votes_percentage || 0) + '%');

    canGroup
      .appendSelect('span', 'total__votes')
      .text(d => intcomma(d.votes_total || 0));
  }
}

export default RaceResults;
